document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('[data-catalog-menu]').forEach(function(menu){const parents=Array.from(menu.querySelectorAll('[data-menu-parent]'));const panels=Array.from(menu.querySelectorAll('[data-menu-panel]'));function activate(index){parents.forEach(function(parent){parent.classList.toggle('is-active',parent.dataset.menuParent===String(index));});panels.forEach(function(panel){panel.hidden=panel.dataset.menuPanel!==String(index);});}parents.forEach(function(parent){const index=parent.dataset.menuParent;parent.addEventListener('mouseenter',function(){activate(index);});parent.addEventListener('focus',function(){activate(index);});});if(parents.length)activate(parents[0].dataset.menuParent);});});
document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-brands-menu]').forEach(function(menu){
    var input=menu.querySelector('[data-brand-search]');
    var links=Array.from(menu.querySelectorAll('[data-brand-link]'));
    var empty=menu.querySelector('[data-brand-empty]');
    if(!input)return;
    input.addEventListener('input',function(){
      var q=(input.value||'').trim().toLowerCase();
      var visible=0;
      links.forEach(function(link){
        var name=(link.getAttribute('data-brand-name')||link.textContent||'').toLowerCase();
        var show=!q||name.indexOf(q)!==-1;
        link.hidden=!show;
        if(show)visible++;
      });
      if(empty)empty.hidden=visible!==0;
    });
  });
});
